import { Component } from '@angular/core';

@Component({
  selector: 'science-behind-hurrey-scope',
  standalone: true,
  imports: [],
  templateUrl: './science-behind-hurrey-scope.component.html',
  styleUrl: './science-behind-hurrey-scope.component.scss'
})
export class ScienceBehindHurreyScopeComponent {

}
